export default "__VITE_ASSET__DpJZ2lu9__"